import {
  SELECT_REGION,
  SELECT_REGION_CLASS,
  GET_ALL_REGIONS_AND_CLASSIFY
} from '../../actionTypes';
import {
  PENDING,
  SUCCESS,
  FAILURE
} from '../../../utils/status';

import {combineReducers} from 'redux';


export default combineReducers({
  allRegions,
  selected,
  selectedClass
});



function allRegions(state = {}, action) {
  let nextState;

  if (action.type === GET_ALL_REGIONS_AND_CLASSIFY) {
    switch (action.status) {
      case PENDING:
      case FAILURE:
        nextState = {
          ...state,
          status: action.status
        };
        break;
      case SUCCESS:
        nextState = {
          ...state,
          status: action.status,
          data: action.data
        };
        break;
      default:
        nextState = state;
    }
  } else {
    nextState = state;
  }

  return nextState;
}

function selected(state = {}, action) {
  if (action.type === SELECT_REGION) {
    return action.data;
  } else {
    return state;
  }
}

function selectedClass(state = -1, action) {
  if (action.type === SELECT_REGION_CLASS) {
    return action.data;
  } else {
    return state;
  }
}




// WEBPACK FOOTER //
// ./src/store/reducers/region/index.js